import {
  createActionTypes,
  createAsyncActionTypes,
} from '../../util/createLifeomicActionTypes';

const asyncActions = createAsyncActionTypes([
  'CREATE_CHECKOUT_PAGE',
  'CREATE_CHECKOUT_PAGE_START',
  'CREATE_CHECKOUT_PAGE_SUCCESS',
  'CREATE_CHECKOUT_PAGE_ERROR',
  'CHECKOUT_FINALIZATION',
  'CHECKOUT_FINALIZATION_START',
  'CHECKOUT_FINALIZATION_SUCCESS',
  'CHECKOUT_FINALIZATION_ERROR',
]);

const actions = createActionTypes([
  'START_CHECKOUT',
  'SHOW_PRICES',
  'CHECKOUT_PAGE_SET_ACCOUNT',
  'CHECKOUT_PAGE_SET_SELECT_OPTION',
  'CHECKOUT_PAGE_LOADED',
  'CHECKOUT_RESET',
  'CHECKOUT_START',
  'CHECKOUT_SUCCESS',
  'CHECKOUT_FAIL',
]);

export default {
  ...asyncActions,
  ...actions,
};
